import { WatchlistId } from "./WatchlistId";
import {Pair} from "../../types/GenericTypes";
import {SortingDirection} from "../../components/ui/sort-indicator/SortingDirection";

export enum WatchlistSortColumn {
    CODE = "CODE",
    CHANGE = "CHANGE"
}

export interface WatchlistSortOptions {
    readonly column: WatchlistSortColumn;
    readonly direction: SortingDirection;
}

export type WatchlistSorting = WatchlistSortOptions | null;

export function toggleOptions(current: WatchlistSorting, column: WatchlistSortColumn): WatchlistSorting {
    if (current == null) {
        return {
            column,
            direction: SortingDirection.ASCENDING
        };
    }

    if (current.column === column) {
        if (current.direction === SortingDirection.ASCENDING) {
            return {
                column,
                direction: SortingDirection.DESCENDING
            };
        } else {
            return null;
        }
    } else {
        return {
            column,
            direction: SortingDirection.ASCENDING
        };
    }
}

export interface WatchlistSortConfig {
    [key: string]: WatchlistSorting;
}

export function updateConfig(current: WatchlistSortConfig | null,
                             change: Pair<WatchlistId, WatchlistSortColumn>): WatchlistSortConfig {
    const column = change[1];
    const id = change[0];
    if (current == null) {
        return {
            [id]: toggleOptions(current, column)
        };
    } else {
        const sorting = current[id];
        const updated = toggleOptions(sorting, column);
        return {
            ...current,
            [id]: updated
        };
    }
}
